module.exports = __webpack_public_path__ + "img/award__coupon.817f55b.png";